import { useQuery } from '@tanstack/react-query'
import { usersService } from '@/services/users'
import { queryKeys } from '@/lib/query-keys'
import { authService } from '@/services/auth'

export function useUser() {
  const isAuthenticated = authService.isAuthenticated()

  return useQuery({
    queryKey: queryKeys.users.me,
    queryFn: () => usersService.getMe(),
    enabled: isAuthenticated,
  })
}
